<template>
  <div>
    <v-container :class="$vuetify.breakpoint.mdAndUp ? '' : 'd-flex flex-column-reverse '"
      v-if="selectedCampaign && selectedCampaign.benefitRule != 3">
      <div class="mr-12">
        <v-chip
          style="color: white"
          color="#ea412a"
          label
          v-if="selectedCampaign.benefitRule"
        >
          <span v-if="selectedCampaign.benefitRule == 1"
            >{{ selectedCampaign.benefitQty }} for
            {{ selectedCampaign.benefitValue1 }}</span
          >
          <span v-if="selectedCampaign.benefitRule == 2"
            >{{ selectedCampaign.benefitQty }} for kr
            {{selectedCampaign.benefitValue1 | currency()}}</span
          >
        </v-chip>
        <v-chip
          style="color: white"
          color="#ea412a"
          label
          v-if="selectedCampaign.additionalValue"
        >
          {{ selectedCampaign.additionalValue }}%
        </v-chip>
        <h2>{{ selectedCampaign.campaignName }}</h2>
        <div
          class="my-3 pr-5"
          style="display: flex; align-items: center; justify-content: start;"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                size="16"
                :color="selectedCampaignDuration.alert ? 'red' : ''"
              >
                schedule
              </v-icon>
            </template>
            <span>Kampanje tilgjengelig til</span>
          </v-tooltip>
          <span
            style="text-transform: capitalize;"
            :style="{ color: selectedCampaignDuration.alert ? 'red' : '' }"
            >{{ selectedCampaignDuration.time }}</span
          >
        </div>
        <span class="campaign-description" v-html="selectedCampaign.information.replaceAll('\n', '<br/>')"></span>
      </div>
      <div :class="$vuetify.breakpoint.mdAndUp? 'ml-12': ''" :style="$vuetify.breakpoint.mdAndUp?'width: 35%':'margin-bottom: 20px'">
        <v-img
          :src="selectedCampaign.imgUrl"
          class="mx-auto"
          width="100%"
          lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="
          transition="fade-transition"
        >
        </v-img>
      </div>
    </v-container>


    <div v-if="selectedCampaign && selectedCampaign.benefitRule == 3" :class="$vuetify.breakpoint.mdAndUp ? 'd-flex justify-space-between' : 'd-flex flex-column pt-4'" class="freebie-campaign">
      <div :style="$vuetify.breakpoint.mdAndUp ? 'width: 62%' : 'margin-bottom: 20px'">
        <div style="position: relative">
          <div class="campaign-circle">
            <div class="campaign-circle-text-pricerule3">
              <b class="value">Kjøp {{ campaign.benefitQty }} få 1 gave</b>
            </div>	
          </div>
          <v-img :src="campaign.imgUrl" class="mx-auto" width="100%" lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg==" transition="fade-transition"> </v-img>
        </div>
        <div class="mr-12 mt-4">
          <h2 class="mb-6" style="color: var(--v-primary-base)">{{ selectedCampaign.campaignName }}</h2>
          <span class="campaign-description">{{ selectedCampaign.information }}</span>
          <div
            class="mt-1 pr-5"
            style="display: flex; align-items: center; justify-content: start;"
          >
            <span class="pr-1">Gyldig til </span>
            <span
              style="text-transform: capitalize;"
              :style="{ color: selectedCampaignDuration.alert ? 'red' : '' }"
              >{{ selectedCampaignDuration.time }}</span
            >
          </div>
        </div>
      </div>
      <div :class="$vuetify.breakpoint.mdAndUp ? 'h-full' : 'd-flex justify-center'">
        <webshop-product-item
              :class="{
                'pb-3 mr-6': $vuetify.breakpoint.smAndUp,
                'pl-2': $vuetify.breakpoint.xs,
                'text-center': $vuetify.breakpoint.smAndUp,
              }"
              :product="campaign.additionalProduct"
              :campaign="campaign"
              :isAdditionalProduct="true"
              :isCampaignView="$route.name === 'webshopCampaignProducts'"
            />
      </div>
      
    </div>
  </div>
</template>
<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import WebshopProductItem from "./WebshopProductItem";

export default {
  mixins: [webshopMixins],
  components: {
    WebshopProductItem,
  },
  computed: {
    campaign() {
      return this.$store.getters["campaigns/getCampaign"]
    },
    additionalProductTitle() {
      return this.selectedCampaign.additionalProduct != undefined ? this.selectedCampaign.additionalProduct.title : 'et produkt '
    }
  }
};
</script>
<style lang="scss">
.campaign-description {
  font-family: "niveau-grotesk", sans-serif;
}
.freebie-campaign {
	@media only screen and (min-width: 700px) {
		.campaign-circle {
			position: absolute;
			border-radius: 0 0 100% 0;
			width: 15%;
			height: 25%;
			color: white;
			background-color: #ea412a;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: start;
      overflow: hidden;
			.campaign-circle-text-pricerule3 {
				position: relative;
        margin-left: 8px;
        font-size: 14px;
        font-weight: 700;
        line-height: 17.5px;
        letter-spacing: -0.5px;
			}
		}
	}
	@media only screen and (max-width: 700px) {
		.campaign-circle {
			position: absolute;
			border-radius: 0 0 100% 0;
			width: 30%;
			height: 30%;
			color: white;
			background-color: #ea412a;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: start;
      overflow: hidden;
			.campaign-circle-text-pricerule3 {
				position: relative;
        margin-left: 8px;
        font-size: 14px;
        font-weight: 700;
        line-height: 17.5px;
        letter-spacing: -0.5px;
			}
		}
	}
}
</style>
